<template>
  <div class="card">
    <div class="delivery">
      <!-- <div class="delivery-list" v-for="(item, index) in qualificationList" :key="index" >
      <van-row class="info-line">
        <van-col :span="16"><span>编号: </span><span>{{item.no}}</span></van-col>
        <van-col :span="8"><span>驾驶员</span></van-col>
      </van-row>
      <van-row class="info-line">
        <van-col :span="8"><span>孙佳旭</span></van-col>
        <van-col :span="10"><span>电话: </span><span>{{item.no}}</span></van-col>    
      </van-row>
      <van-row class="info-line">
        <van-col :span="24"><span>身份证号: </span><span>{{item.idCard}}</span></van-col>
      </van-row>
      <van-row class="info-line">
        <van-col :span="12"><span>危化品资质：</span><span>有</span></van-col>
        <van-col :span="12"><span  class="info-value status">状态: </span><span>{{item.status}}</span></van-col>    
      </van-row>
      
      </div> -->

      <div class="card-header">
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">编号</span>
            <span>:</span>
            <span class="info-value">{{ complaint.consigneeCode }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">类型</span>
            <span>:</span>
            <span class="info-value">{{ complaint.consigneeType=='01'?'驾驶员':'押运员' }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">姓名</span>
            <span>:</span>
            <span class="info-value">{{ complaint.name }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">电话</span>
            <span>:</span>
            <span class="info-value">{{ complaint.contactPhone }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="24">
            <span class="info-title">身份证号</span>
            <span>:</span>
            <span class="info-value"> {{ complaint.idCardNumber }}</span>
          </van-col>
   
        </van-row>

        <div class="van-hairline--top">
          <van-row class="info">
            <van-col span="18">
              <span class="info-title">危化品资质</span>
              <span>:</span>
              <span class="info-value">{{ complaint.chemicalsTransportQualification=='0'?'无':'有'}}</span>
            </van-col>  
            <van-col span="6">
              <span class="info-value status">待审核</span>
            </van-col>
          </van-row>
        </div>
        
      </div>


     
    </div>
  </div>
</template>
<script>
// import orderApi from "@/request/orderApi";
export default {
  name: "QualificationCard",
  props: {
    // order: Object,
    complaint: Object
  },
  data() {
    return {
  qualificationList: [
    {no: "YZD20201229", idCard: "410901198810240988", date: "2021-1-20", status: "审核通过"},
    {no: "YZD20201230", idCard: "410901198810240988", date: "2020-10-20", status: "已过期"},
    {no: "YZD20201231", idCard: "410901198810240988", date: "2021-1-12", status: "待审核"},
  ]

     
    };
  },
  computed: {
    
  
  },
  methods: {
    toDetails() {
      this.$router.push("/qualificationDetails");
    }
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';
/* .font30 {
  font-size: 30px;
}
.delivery-list >>> .van-col {
    line-height: 50px;
} */

.card {
  margin-top: 10px;
  background: #ffffff;
  padding: 12px 24px;
  font-size: 26px;
  border-radius: 20px;
  .card-header {
    // margin-bottom: 20px;
  }

  .card-header, .card-total, .card-info {
    padding: 12px 0;
  }

  .card-info, .card-total {
    color: #666666;
  }

  .info {
    line-height: 61px;

    .info-title {
      display: inline-block;
      min-width: 80px;
      text-align: justify;
      text-align-last: justify;
    }

    .info-value {
      margin-left: 16px;
    }

    .status {
      padding: 8px 12px;
      border: 1px solid black;
      border-radius: 10px;
    }
  }

  .color-red {
    color: #E12020;
  }

  .large {
    font-size: 36px;
  }

  .card-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 120px;

    .btn {
      min-width: 200px;
      height: 72px;
      background: $gradientColor;
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>